import { render, staticRenderFns } from "./AppDelete.vue?vue&type=template&id=2b1055fa&scoped=true&"
import script from "./AppDelete.vue?vue&type=script&lang=js&"
export * from "./AppDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1055fa",
  null
  
)

export default component.exports